import request from './request'

// 1. 发送验证码
export function sendSmsCode(data) {
  return request({
    url: '/api/sms/sendCode',
    method: 'post',
    data
  })
}

// 2. 企业绑定手机
export function bindMobile(data) {
  return request({
    url: '/api/user/business/bindMobile',
    method: 'post',
    data
  })
}

// 3. 企业信息中心
export function getBusinessCenter(params) {
  return request({
    url: '/api/user/business/center',
    method: 'get',
    params
  })
}

// 4. 企业修改密码
export function changePassword(data) {
  return request({
    url: '/api/user/business/changePassword',
    method: 'post',
    data
  })
}

// 5. 企业忘记密码
export function forgotPwd(data) {
  return request({
    url: '/api/user/business/forgotPwd',
    method: 'post',
    data
  })
}

// 6. 企业重置密码
export function resetPassword(data) {
  return request({
    url: '/api/user/business/resetPassword',
    method: 'post',
    data
  })
}

// 7. 更新企业用户信息
export function updateBusinessUser(data) {
  return request({
    url: '/api/user/business/update',
    method: 'post',
    data
  })
}

// 8. 企业手机验证码登录
export function loginEmail(data) {
  return request({
    url: '/api/login/business/mobileLogin',
    method: 'post',
    data
  })
}
